unit ImportBatch;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, BaseForm, WEBLib.ExtCtrls, WEBLib.Actions, Data.DB, WEBLib.DB, WEBLib.WebCtrls,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls;

type
  TImportBatchForm = class(TBaseEditForm)
  private
    { Private declarations }
  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;

var
  ImportBatchForm: TImportBatchForm;

implementation

{$R *.dfm}

procedure TImportBatchForm.LoadDFMValues;
begin
  inherited LoadDFMValues;


  try
    ElementClassName := '';
  finally
  end;
end;

end.